import { Dialog } from "@finanedi.es/storybook"
import { useCesionById } from "api/Cesion.hook"
import { GetCesionByFiltersDtoProps } from "api/DTOs/GetCesionByFiltersDto"
import { useValidacionesPendientesUsuario } from "api/Usuario.hook"
import LoadingModal from "features/Tesoreria/pages/Bancos/components/LoadingModal"
import NewAceptacionCesionForm from "features/Validaciones/forms/AceptacionCesionForm"
import {
  MODAL_TYPE_KEYS,
  MODAL_TYPE_LOADING_SETUP,
} from "features/Validaciones/forms/VerificarCesionForm/constant"
import { useState } from "react"
import { useTranslation } from "react-i18next"

const AceptarCesionModal = ({
  fetchTableData,
  modal,
  close,
}: {
  fetchTableData: () => void
  modal: {
    show: boolean
    rowData: GetCesionByFiltersDtoProps | undefined
  }
  close: () => void
}) => {
  const { t } = useTranslation()
  const [showLoadingModal, setShowLoadingModal] = useState(false)
  const { usuarioValidacionesPendienteRefetch } =
    useValidacionesPendientesUsuario()
  const { cesionById } = useCesionById(modal?.rowData?.id)
  return (
    <Dialog
      visible={modal.show}
      onHide={close}
      header={t("validaciones.modal.title")}
      draggable
      baseZIndex={20}
      style={{ height: "auto" }}
    >
      <section className='tw-w-full tw-flex tw-justify-center'>
        <NewAceptacionCesionForm
          rowData={modal.rowData}
          setShowLoadingModal={setShowLoadingModal}
          fetchTableData={() => {
            usuarioValidacionesPendienteRefetch()
            fetchTableData()
          }}
          onHide={close}
          cesionData={cesionById}
          t={t}
        />
        <LoadingModal
          showModal={showLoadingModal}
          data={MODAL_TYPE_LOADING_SETUP[MODAL_TYPE_KEYS.ACEPTAR_CESION]}
          onHideModal={() => setShowLoadingModal(!showLoadingModal)}
        />
      </section>
    </Dialog>
  )
}

export default AceptarCesionModal
